import { NgModule } from '@angular/core';
import { CorporateLicenseComponent } from './corporate-license.component';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {path: '', component: CorporateLicenseComponent}
]
@NgModule({
imports: [RouterModule.forChild(routes)],
exports: [ RouterModule]
})
export class CorporateLicenseRoutingModule {

}